var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 30,
    viewBox: "0 0 16 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5002 15.0251C11.0002 14.4765 10.5644 13.9712 10.1157 13.4803C7.103 10.0877 4.07752 6.68055 1.06485 3.28788C0.308483 2.43611 0.321303 1.25228 1.06485 0.487124C1.64175 -0.104789 2.50068 -0.162537 3.12885 0.342755C3.25705 0.443813 3.37243 0.559308 3.47498 0.689241C7.28248 4.977 11.0772 9.25032 14.8846 13.5381C15.7051 14.462 15.7051 15.5448 14.8846 16.4688C11.0643 20.771 7.25684 25.0587 3.43652 29.3609C2.59042 30.3138 1.33407 30.1838 0.744357 29.0866C0.385402 28.4225 0.423861 27.6141 0.846916 26.9933C0.936655 26.8633 1.02639 26.7623 1.12895 26.6468C4.48775 22.8643 7.83373 19.0819 11.1925 15.3138C11.2695 15.2128 11.3848 15.1406 11.5002 15.0251Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/Chevron-Right.a766bb05fb6dac532198a9999549e05c.svg";
export { ForwardRef as ReactComponent };